import { SET_TOASTIFY_STATUS } from "../types/toastifyTypes";

export const setToastifyStatus = (payload) => ({
    type: SET_TOASTIFY_STATUS,
    payload,
});
